import React from "react";
import "../mycontent.css";
import { Form, Input, Button, Card, DatePicker } from "antd";
import { connect } from "react-redux";
import {
  fetchTextbook,
  createTextbook,
  updateTextbook,
  emptyTextbook,
} from "../../../../store/actions/selfTextbookAction";
import { MY_CONTENT_BASE_URL } from "../../../../constants/LookupConst";
import InputSelectAdd from "../../../../components/InputSelectAdd";
import CircularProgress from "../../../../components/CircularProgress";
import { toast } from "react-toastify";
import moment from "moment";

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

class SelfTextbook extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  formRef = React.createRef();

  async componentDidMount() {
    const {
      match: { params },
      fetchTextbook,
    } = this.props;
    if (params.id) {
      await fetchTextbook(params.id);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { selectedTextbook } = this.props;
    if (
      prevProps.selectedTextbook &&
      prevProps.selectedTextbook._id !== selectedTextbook._id
    ) {
      this.setState({
        mainsubjectname: selectedTextbook.mainsubjectname,
        subsubjectname: selectedTextbook.subsubjectname,
      });
    }
  }

  onMainSubjectNameChange = (data) => {
    this.setState({ mainsubjectname: data });
  };
  onSubSubjectNameChange = (data) => {
    this.setState({ subsubjectname: data });
  };

  async componentWillUnmount() {
    this.props.emptyTextbook();
  }

  render() {
    const onFinish = async (values) => {
      const { history } = this.props;
      const { mainsubjectname, subsubjectname } = this.state;
      if (!params.id) {
        await this.props.createTextbook(
          { ...values, mainsubjectname, subsubjectname },
          (res) => {
            if (res.success) {
              toast.success(res.message);
            } else {
              toast.error(res.message);
            }
          }
        );
      } else {
        await this.props.updateTextbook(
          { ...values, mainsubjectname, subsubjectname },
          params.id,
          (res) => {
            if (res.success) {
              toast.success(res.message);
            } else {
              toast.error(res.message);
            }
          }
        );
      }
      history.push(`${MY_CONTENT_BASE_URL}?tab=book`);
    };

    const {
      // lookupTextbookYears,
      // location: { search },
      match: { params },
      selectedTextbook,
      loading,
      // countries,
      // professors,
    } = this.props;
    const data = selectedTextbook;
    if (!(data && data._id) && params.id) {
      return (
        <div className="gx-loader-view">
          <CircularProgress />
        </div>
      );
    }
    return (
      <Card className="gx-card blast-mc" title="Create Textbook">
        {!loading ? (
          <Form
            ref={this.formRef}
            {...formItemLayout}
            name="register"
            onFinish={onFinish}
            scrollToFirstError
          >
            <Form.Item
              name="title"
              label="Title"
              initialValue={data.title}
              rules={[
                {
                  type: "string",
                  message: "The input is not valid title",
                },
                {
                  required: true,
                  message: "Please input title",
                },
              ]}
            >
              <Input placeholder="Please enter a title" value={data.title} />
            </Form.Item>
            <InputSelectAdd
              category={"mainsubjectname"}
              placeholder={`Please assign main subject name`}
              onChange={this.onMainSubjectNameChange}
              parenttype={"reading"}
              name={"mainsubjectname"}
              initialValue={this.state.mainsubjectname}
              label={"Main Subject Name"}
            />
            <InputSelectAdd
              category={"subsubjectname"}
              placeholder={`Please assign sub subject name`}
              onChange={this.onSubSubjectNameChange}
              parenttype={"reading"}
              name={"subsubjectname"}
              initialValue={this.state.subsubjectname}
              label={"Sub Subject Name"}
            />
            <Form.Item
              name="author"
              label="Author"
              initialValue={data.author}
              rules={[
                {
                  type: "string",
                  message: "The input is not valid author",
                },
                // {
                //   required: true,
                //   message: "Please input author",
                // },
              ]}
            >
              <Input placeholder="Please enter author" value={data.author} />
            </Form.Item>
            <Form.Item
              name="isdn"
              label="ISDN"
              initialValue={data.isdn}
              rules={[
                {
                  type: "string",
                  message: "The input is not valid isdn",
                },
                // {
                //   required: true,
                //   message: "Please input isdn",
                // },
              ]}
            >
              <Input placeholder="Please enter isdn" value={data.isdn} />
            </Form.Item>
            <Form.Item
              name="url"
              label="URL"
              initialValue={data.url}
              rules={[
                {
                  type: "url",
                  message: "The input is not valid url",
                },
                // {
                //   required: true,
                //   message: "Please input url",
                // },
              ]}
            >
              <Input placeholder="Please enter url" value={data.url} />
            </Form.Item>
            <Form.Item
              name="publisher"
              label="Publisher"
              initialValue={data.publisher}
              rules={[
                {
                  type: "string",
                  message: "The input is not valid publisher",
                },
                // {
                //   required: true,
                //   message: "Please input publisher",
                // },
              ]}
            >
              <Input
                placeholder="Please enter publisher"
                value={data.publisher}
              />
            </Form.Item>
            <Form.Item
              name="edition"
              label="Edition"
              initialValue={data.edition}
              rules={[
                {
                  type: "string",
                  message: "The input is not valid edition",
                },
                // {
                //   required: true,
                //   message: "Please input edition",
                // },
              ]}
            >
              <Input placeholder="Please enter edition" value={data.edition} />
            </Form.Item>
            <Form.Item
              name="date"
              label="Published date"
              // rules={[
              //   {
              //     required: true,
              //     message: "Please select test date!",
              //   },
              // ]}
              initialValue={data.date ? moment(data.date) : moment()}
            >
              <DatePicker
                placeholder="Please enter a published date"
                // value={scheduledAt}
                format="MM/DD/YYYY"
                className="gx-w-100"
                // onChange={this.onDateChange}
              />
            </Form.Item>
            <Form.Item
              name="additionalinformation"
              label="Additional Information"
              initialValue={data.additionalinformation}
              rules={[
                {
                  type: "string",
                  message: "The input is not valid additionalinformation",
                },
                // {
                //   required: true,
                //   message: "Please input additionalinformation",
                // },
              ]}
            >
              <Input
                placeholder="Please enter a additionalinformation"
                value={data.additionalinformation}
              />
            </Form.Item>
            <Form.Item {...tailFormItemLayout}>
              <Button type="primary" htmlType="submit">
                {!!params.id ? "Update" : "Create"}
              </Button>
            </Form.Item>
          </Form>
        ) : (
          <div className="gx-loader-view">
            <CircularProgress />
          </div>
        )}
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedTextbook: state.selftextbooks.selectedTextbook,
  loading: state.selftextbooks.loading,
});

const mapDispatchToProps = {
  createTextbook,
  fetchTextbook,
  updateTextbook,
  emptyTextbook,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelfTextbook);
